import {
    PracticeAreaBody,
    Card,
    CardTitle,
    CardDescription,
    FirstCardContainer,
    PracticeAreaBodyFirstRow,
    SecondCardContainer,
    FirstCardBodyFirstRow,
    FirstImage, 
    Circle,
    SecondCardFirstRow,
    Arrow,
    SecondImage,
    ThirdImage,
    ForthImage,
    PracticeAreaBodySecondRow,
    ForthCardFirstRow,
    MiniFirstImage,
    MiniSecondImage,
    MiniThirdImage,
    MiniForthImage
   } from './style'
import React  from 'react';
import { useScreenSize } from '../../hooks/useScreenSize';
import RightArrow from '../../image/right-arrow.png';


import { Flex } from 'reflexbox'

export const PracticeAreaFourCards = ({
  firstCard,
  secondCard,
  thirdCard,
  forthCard,
  haveArrow = true
}) => {

  const openInNewTab = (url) => {
    console.log(url);
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const screenSize = useScreenSize();

    return (
        <PracticeAreaBody>
          <PracticeAreaBodyFirstRow>
            <FirstCardContainer width="42%">
              <Card bgColor="#9A302C" color="#ffffff">
              {screenSize < 560 ?
                  <div>
                    <div>
                      <MiniFirstImage 
                        src={firstCard && firstCard.image} 
                        alt="" />
                    </div>
                    <Flex 
                      flexDirection="row" 
                      marginTop="28px" 
                      marginBottom="16px"
                    >
                      <Flex flexDirection="column" width="100%">
                        <CardTitle>
                          {firstCard && firstCard.title}
                        </CardTitle>
                        <CardDescription>
                          {firstCard && firstCard.description}
                        </CardDescription>
                      </Flex>
                      {haveArrow && (
                        <Flex
                          flexDirection='column' 
                          justifyContent='flex-end'
                        >
                          <Circle onClick={() => openInNewTab(firstCard.url)}>
                            <Arrow src={RightArrow} alt ="" />
                          </Circle>
                        </Flex>
                      )}
                    </Flex>
                  </div>
                :
                  <>
                    <FirstCardBodyFirstRow>
                      <CardTitle>
                        {firstCard && firstCard.title}
                      </CardTitle>
                      <CardDescription>
                        {firstCard && firstCard.description}
                      </CardDescription>
                    </FirstCardBodyFirstRow>

                    <Flex 
                      flexDirection='column' 
                      width='37%'
                    >
                      <FirstImage 
                        src={firstCard && firstCard.image} 
                        alt="" />
                      {haveArrow && (
                        <Flex
                        flexDirection='row' 
                        justifyContent='flex-end'
                        width='100%'
                        height='auto'
                        paddingRight="16px"
                        paddingBottom="0px"
                        paddingTop='8px'
                      >
                        <Circle onClick={() => openInNewTab(firstCard.url)}>
                          <Arrow src={RightArrow} alt ="" />
                        </Circle>
                      </Flex>
                      )}
                    </Flex>
                  </>
                }
              </Card>
            </FirstCardContainer>

            <SecondCardContainer width="56%">
              <Card bgColor='#E6BD73' color="#000000">
                {screenSize < 560 ? 
                  <Flex flexDirection="column">
                    <div>
                      <MiniSecondImage 
                        src={secondCard && secondCard.image} 
                        alt="" />
                    </div>
                    <Flex 
                      flexDirection="row" 
                      marginTop="28px" 
                      marginBottom="16px"
                    >
                      <Flex flexDirection="column" width="100%">
                        <CardTitle>
                          {secondCard && secondCard.title}
                        </CardTitle>
                        <CardDescription>
                          {secondCard && secondCard.description}
                        </CardDescription>
                      </Flex>
                      {haveArrow && (
                       <Flex
                        flexDirection='column' 
                        justifyContent='flex-end'
                      >
                        <Circle onClick={() => openInNewTab(secondCard.url)}>
                          <Arrow src={RightArrow} alt ="" />
                        </Circle>
                      </Flex> 
                      )}
                    </Flex>
                  </Flex>
                   : 
                  <>
                    <SecondCardFirstRow>
                      <CardTitle>
                        {secondCard && secondCard.title}
                      </CardTitle>
                      <CardDescription>
                        {secondCard && secondCard.description}
                      </CardDescription>
                    </SecondCardFirstRow>
                    <Flex 
                      flexDirection='column' 
                      width='37%'
                      position="fixed"
                      bottom="0px"
                    >
                      <SecondImage 
                        src={secondCard && secondCard.image} 
                        alt=""
                      />
                      {haveArrow && (
                       <Flex 
                       flexDirection='row' 
                       justifyContent='flex-end'
                       width='100%'
                       height='auto'
                       paddingRight="16px"
                       paddingBottom="0px"
                       paddingTop='8px'
                     >
                       <Circle onClick={() => openInNewTab(secondCard.url)}>
                         <Arrow src={RightArrow} alt ="" />
                       </Circle>
                     </Flex> 
                      )}
                    </Flex>
                  </>
                }
              </Card>
            </SecondCardContainer>

          </PracticeAreaBodyFirstRow>

          <PracticeAreaBodySecondRow>
            <FirstCardContainer width="56%">
              <Card bgColor="#56A6A7" color="#000000">
                {screenSize < 560 ?
                  <div>
                  <div>
                    <MiniThirdImage 
                      src={thirdCard && thirdCard.image} 
                      alt="" />
                  </div>
                  <Flex 
                    flexDirection="row" 
                    marginTop="28px" 
                    marginBottom="16px"
                  >
                    <Flex flexDirection="column" width="100%">
                      <CardTitle>
                        {thirdCard && thirdCard.title}
                      </CardTitle>
                      <CardDescription>
                        {thirdCard && thirdCard.description}
                      </CardDescription>
                    </Flex>
                    {haveArrow && (
                      <Flex
                      flexDirection='column' 
                      justifyContent='flex-end'
                    >
                      <Circle onClick={() => openInNewTab(thirdCard.url)}>
                        <Arrow src={RightArrow} alt ="" />
                      </Circle>
                    </Flex> 
                    )}
                  </Flex>
                </div>:
                  <>
                    <SecondCardFirstRow>
                      <CardTitle>
                        {thirdCard && thirdCard.title}
                      </CardTitle>
                      <CardDescription>
                        {thirdCard && thirdCard.description}
                      </CardDescription>
                    </SecondCardFirstRow>
                    <Flex
                      flexDirection='column' 
                      width='32%'
                      position="fixed"
                      bottom="0px"
                    >
                      <ThirdImage 
                        src={thirdCard && thirdCard.image} 
                        alt=""
                      />
                      {haveArrow && (
                       <Flex 
                       flexDirection='row' 
                       justifyContent='flex-end'
                       width='100%'
                       height='auto'
                       paddingRight="16px"
                       paddingBottom="0px"
                       paddingTop='8px'
                     >
                       <Circle onClick={() => openInNewTab(thirdCard.url)}>
                         <Arrow src={RightArrow} alt ="" />
                       </Circle>
                     </Flex> 
                      )}
                    </Flex>
                  </>
                }
              </Card>
            </FirstCardContainer>

            <SecondCardContainer width="42%">
              <Card bgColor='#255371' color="#ffffff">
                {screenSize < 560 ? 
                  <div>
                    <div>
                      <MiniForthImage 
                        src={forthCard && forthCard.image} 
                        alt="" />
                    </div>
                    <Flex 
                      flexDirection="row" 
                      marginTop="28px" 
                      marginBottom="16px"
                    >
                      <Flex flexDirection="column" width="100%">
                        <CardTitle>
                          {forthCard && forthCard.title}
                        </CardTitle>
                        <CardDescription>
                          {forthCard && forthCard.description}
                        </CardDescription>
                      </Flex>
                      {haveArrow && (
                        <Flex
                        flexDirection='column' 
                        justifyContent='flex-end'
                      >
                        <Circle onClick={() => openInNewTab(forthCard.url)}>
                          <Arrow src={RightArrow} alt ="" />
                        </Circle>
                      </Flex> 
                      )}
                    </Flex>
                  </div>
                : 
                  <>
                    <Flex 
                      marginRight='0px' 
                      flexDirection='row'
                      justifyContent='space-between'
                    >
                      <ForthCardFirstRow>
                        <CardTitle>
                          {forthCard && forthCard.title}
                        </CardTitle>
                        <CardDescription>
                          {forthCard && forthCard.description}
                        </CardDescription>
                      </ForthCardFirstRow>
                      <Flex
                        flexDirection='column'
                        width='34%'
                        height='100%'
                      >
                        <ForthImage 
                          src={forthCard && forthCard.image} 
                          alt="" 
                        />
                        {haveArrow && (
                          <Flex 
                          flexDirection='row' 
                          justifyContent='flex-end'
                          width='100%'
                          height='auto'
                          paddingRight='16px'
                          paddingBottom='0px'
                          paddingTop='8px'
                        >
                          <Circle onClick={() => openInNewTab(forthCard.url)}> 
                            <Arrow src={RightArrow} alt ="" />
                          </Circle>
                        </Flex> 
                        )}
                      </Flex>
                    </Flex>
                  </>
                }
                
              </Card>
            </SecondCardContainer>

          </PracticeAreaBodySecondRow>
      </PracticeAreaBody>
    )
}